"use client";

import { Auth0Provider } from "@auth0/nextjs-auth0";
import { NuqsAdapter } from "nuqs/adapters/next/app";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <Auth0Provider>
      <NuqsAdapter>{children}</NuqsAdapter>
    </Auth0Provider>
  );
}
